<template>
    <component :is="template">
        <div class="contents-area">
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">선물하기</h2>
            </div>

            <div class="contents-area__inner">
                <section class="page-section pt-0">
                    <v-divider class="grey darken-4"/>
                    <template v-for="cart, index in carts">
                        <v-divider v-if="index"/>
                        <pickup-item :key="cart._id" :cart="cart" />
                    </template>
                    <v-divider/>

                    <div class="card--primary">
                        <v-row align="center" justify="center" class="row--x-small font-size-14 font-size-md-16">
                            <v-col cols="auto">
                                <span>총 상품가격(<b>{{ saleAmount.format() }}원</b>)</span>
                            </v-col>
                            <v-col cols="auto">+</v-col>
                            <v-col cols="auto">
                                <span>총 배송비(<b>{{ shippingAmount.format() }}원</b>)</span>
                            </v-col>
                            <v-col cols="auto">=</v-col>
                            <v-col cols="auto">
                                <div class="d-flex align-center">
                                    <span>총 결제 예상 금액</span><b class="font-size-20 font-size-md-24 ml-10px ml-md-12px">{{ totalAmount.format() }}원</b>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <section v-show="false" class="page-section">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">구매자 정보 입력</h3>
                        <v-divider class="grey lighten-1 mt-10px"/>
                    </div>
                    <div class="w-100 mw-500px">
                        <v-row align="center" class="row--x-small">
                            <v-col cols="12">
                                <v-text-field v-model="giftOrder.buyer.name" placeholder="이름" outlined persistent-placeholder hide-details/>
                            </v-col>
                            <v-col cols="12">
                                <v-row align="center" class="row--x-small">
                                    <v-col>
                                        <v-select v-model="giftOrder.buyer.phone1" v-bind="$attrs" :items="phones" placeholder="연락처" outlined persistent-placeholder hide-details />
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-text-field v-model="giftOrder.buyer.phone2" v-bind="$attrs" outlined hide-details maxlength="4" />
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-text-field v-model="giftOrder.buyer.phone3" v-bind="$attrs" outlined hide-details maxlength="4" />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="giftOrder.buyer.email" placeholder="이메일" outlined persistent-placeholder hide-details />
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <section class="page-section">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">선물 받으시는분</h3>
                        <v-divider class="grey lighten-1 mt-10px"/>
                    </div>
                    <div class="w-100 mw-500px">
                        <v-row align="center" class="row--x-small">
                            <v-col>
                                <v-select v-model="giftOrder.receiver.phone1" v-bind="$attrs" :items="phones" placeholder="연락처" outlined persistent-placeholder hide-details />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-text-field v-model="giftOrder.receiver.phone2" v-bind="$attrs" outlined hide-details maxlength="4" />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-text-field v-model="giftOrder.receiver.phone3" v-bind="$attrs" outlined hide-details maxlength="4" />
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <section class="page-section">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">전달 메세지</h3>
                        <v-divider class="grey lighten-1 mt-10px"/>
                    </div>
                    <div>
                        <v-row align="center" class="row--x-small">
                            <v-col>
                                <v-textarea v-model="giftOrder.message" placeholder="문자 전달 메세지" outlined persistent-placeholder rows="3" hide-details/>
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <!-- <section class="page-section">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">결제방법</h3>
                        <v-divider class="grey lighten-1 mt-10px"/>
                    </div>
                    <div>
                        <v-row align="center" class="row--x-small">
                            <v-col>
                                <toss-pay v-if="totalAmount" :paymentAmount="totalAmount" ref="tossPay"/>
                            </v-col>
                        </v-row>
                    </div>
                </section> -->

                <section class="page-section">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">선물약관</h3>
                        <v-divider class="grey lighten-1 mt-10px"/>
                    </div>
                    <div>
                        <div class="page-text">
                            <p>※ 상품 선물 시 상대방의 휴대번호로 SMS URL이 발송되어 거절 또는 수락 후 배송지를 입력할 수 있습니다.</p>
                            <p>※ 수신자가 SMS URL 수신 후 선물 수락 또는 상품 구매 출고 배송 시 취소가 불가능하므로 주의 해 주세요.</p>
                            <p>※ 선물하기로 상품을 발송하시는 경우 일반상품으로 분류되어 소득공제가 불가 합니다.</p>
                        </div>
                    </div>
                    <v-divider class="mt-10px mt-md-20px" />
                </section>

                <section class="page-section pt-0 text-center">
                    <v-checkbox v-model="aggreement" label="동의합니다" hide-details class="d-inline-flex ma-0"/>
                </section>

                <section class="page-section pb-0">
                    <v-row align="center" justify="center" class="row--x-small">
                        <v-col cols="auto">
                            <v-btn @click="pay" x-large color="primary">선물하기</v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn @click="$router.go(-1)" x-large outlined color="grey"><span class="grey--text text--darken-3">취소하기</span></v-btn>
                        </v-col>
                    </v-row>
                </section>
            </div>
        </div>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { giftOrder.shippingAddress.postcode = postcode; giftOrder.shippingAddress.address1 = address; } " />
        <!-- <kcp-pay ref="kcpPay" /> -->
        <nice-pay ref="nicePay"/>
    </component>
</template>
<script>
import api from "@/api";
import { mdiReceipt, mdiBookOpenPageVariant  } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import KcpPay from "@/components/plugins/kcp/kcp-pay.vue";
import NicePay from '@/components/plugins/nice/nice-pay.vue';
import TossPay from "@/components/plugins/toss/toss-pay.vue";
export default {
    components: {
        PickupItem,
        DaumPostcode,
        KcpPay,
        NicePay,
        TossPay
    },
    data(){
        return {
            mdiReceipt,
            mdiBookOpenPageVariant,
            aggreement: false,
            giftOrder: {
                _id: null,
                carts: [],
                buyer: {
                    _id: null,
                    name: null,
                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,
                    email: null,
                },
                receiver: {
                    name: null,
                    phone:  null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,
                    email: null,
                },
                shippingAddress: {
                    postcode: null,
                    address1: null,
                    address2: null
                },
                demand: '',
                message: '',
                point: 0,
                cash: 0,
                shippingAmounts: 0,
            },
            carts: [],
            phones: ["010", "011", "016", "017", "019"]
        }
    },
    async mounted(){
        await this.init();
        // this.$refs.tossPay.init();
    },
    methods: {
        async init(){
            // 쇼핑몰 설정정보
            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;
            // 상품페이지 & 장바구니에서 픽업된 상품 로드
            let carts = this.$store.state.pickupItems;
            if(!carts.length){
                alert("구매하실 상품을 선택해주세요");
                this.$router.go(-1);
                return;
            }
            this.$store.dispatch("checkout");
            this.carts = carts;
            this.giftOrder.pickups = carts.map(cart => ({ _product: cart.product._id, quantity: cart.quantity }));
            //
            if(this.logon){
                let { me } = await api.v1.me.profile.get();
                let { _id, name, username, phone, email, postcode, address1, address2 } = me;
                let [ phone1, phone2, phone3 ] = phone?.phoneNumberFormat?.()?.split?.('-') || [];
                this.$set(this.giftOrder, "buyer", {
                    _id,
                    name,
                    username,
                    phone, phone1, phone2, phone3,
                    email
                });
                // this.$set(this.giftOrder, "shippingAddress", {
                //     postcode,
                //     address1,
                //     address2
                // });
            }
        },
        validate(){
            try{
                if(!this.giftOrder.receiver.phone) throw new Error("선물받는사람 연락처를 입력해주세요");
                if(!this.aggreement) throw new Error("선물하기 약관에 동의해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async pay(){
            if(this.validate()){
                let { giftOrder } = await api.v1.shop.giftOrders.post(this.giftOrder);
                console.log(giftOrder);
                if(giftOrder.paymentAmount){
                    // this.$refs.kcpPay.orderNo = giftOrder.orderNo;
                    // this.$refs.kcpPay.orderName = this.carts[0].product.name;
                    // this.$refs.kcpPay.paymentAmount = giftOrder.paymentAmount;
                    // this.$refs.kcpPay.buyerName = giftOrder.buyer.name;
                    // this.$refs.kcpPay.buyerPhone = giftOrder.buyer.phone;
                    // this.$refs.kcpPay.buyerEmail = giftOrder.buyer.email;
                    // this.$refs.kcpPay.pay();
                    this.$refs.nicePay.amt = giftOrder.paymentAmount;
                    this.$refs.nicePay.goodsName = this.carts[0].product.name;
                    this.$refs.nicePay.moid = giftOrder.orderNo;
                    this.$refs.nicePay.buyerName = giftOrder.buyer.name
                    this.$refs.nicePay.buyerEmail = giftOrder.buyer.email
                    this.$refs.nicePay.buyerTel = giftOrder.buyer.phone
                    this.$refs.nicePay.nicepayStart();

                    // this.$refs.tossPay.orderId = giftOrder.orderNo
                    // this.$refs.tossPay.orderName = this.carts[0].product.name
                    // this.$refs.tossPay.customerEmail = giftOrder.buyer.email
                    // this.$refs.tossPay.customerName = giftOrder.buyer.name
                    // this.$refs.tossPay.order = giftOrder
                    // this.$refs.tossPay.clickPaymentButton();
                }
            }
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },
        accessToken(){
            return this.$store.state.accessToken;
        },
        logon(){
            return !!this.accessToken;
        },
        saleAmount(){
            return this.carts.reduce((saleAmount, cart) => saleAmount + cart.product.salePrice * cart.quantity, 0);
        },
        shippingAmount(){
            let pickups = this.carts;
            let shippingAmount = 0;
            let setting = this.setting;
            // 상품 배송정책
            shippingAmount += pickups.filter(pickup => pickup.product.shippingCode == "self").reduce((shippingAmount, pickup) => +pickup.product.shippingPrice + shippingAmount, 0);
            // 주문 배송정책
            let saleAmount = pickups.filter(pickup => pickup.product.shippingCode == "order").reduce((saleAmount, pickup) => saleAmount + pickup.product.salePrice * pickup.quantity, 0);
            if(pickups.some(pickup => pickup.product.shippingCode == "order")) shippingAmount += setting.saleAmount <= saleAmount ? setting.shippingPrice.gt : setting.shippingPrice.lt;
            this.giftOrder.shippingAmounts = shippingAmount
            return shippingAmount;
        },
        totalAmount(){
            return this.saleAmount + this.shippingAmount;
        }
    },
    watch: {
        giftOrder: {
            deep: true,
            handler(value){
                var { phone1, phone2, phone3 } = value.buyer;
                value.buyer.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;
                var { phone1, phone2, phone3 } = value.receiver;
                value.receiver.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;
            }
        }
    }
}
</script>
<style scoped>
.row + .row {
    margin-top: 0px;
}
</style>